<!-- GoodsListBlock -->

<template>
  <div>
    <van-grid :border="false" :column-num="colCount" style="
        border-radius: 10px;
        width: 100%;
        white-space: nowrap;
        overflow-x: auto;
        display: block;
      ">
      <van-grid-item v-for="goods in goodsList" :key="goods.goodsId" class="goods-info"
        @click="goGoodsDetail(goods.goodsId)">
        <template #icon>
          <van-image :height="iconHeight" :src="goods.headImage" :width="iconWidth" />
        </template>

        <template #text>
          <div :style="{ width: iconWidth }" class="goods_name van-ellipsis">
            {{ goods.name }}
          </div>
          <div class="goods_price">
            <div class="price">
              <img class="icon"
                src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
              <span class="text">{{ goods.price | money }}</span>
            </div>
            <div v-if="visiblePay" class="cert">
              <div class="iconfont icon-gouwuche" @click.stop="addCart(goods)"></div>
            </div>
          </div>
          <div v-if="visibleSellCount" style="
              font-size: 12px;
              color: #939393;
              text-align: left;
              width: 100%;
            ">
            <span>已售 {{ goods.saleCount }}</span>
          </div>
        </template>

        <slot :goodsInfo="goods" name="content"></slot>
      </van-grid-item>
    </van-grid>

    <goods-spec ref="spec" :cate-code="goodsInfo.cateCode" :goods-id="goodsInfo.goodsId"
      :head-image="goodsInfo.headImage" :name="goodsInfo.name" :price="goodsInfo.price"
      :sale-count="goodsInfo.saleCount" :spec="goodsInfo.spec" :spec-visible="specVisible"></goods-spec>
  </div>
</template>

<script>
import { get_goods_list_by_store_index } from "@/api/goods-api";
import GoodsSpec from "@/components/common/goods-spec";
import { mall_util_order_buy_goods } from "@/util/orders";

export default {
  name: "goods-list-block",

  components: { GoodsSpec },

  props: {
    tags: { type: String },
    cateId: { type: Number, default: 0, required: true }, //商品类别编号
    iconWidth: { type: Number, default: 98 }, //商品图宽度
    iconHeight: { type: Number, default: 98 }, //商品图高度
    visibleOriginalPrice: { type: Boolean, default: false }, //是否显示市场价
    visibleCart: { type: Boolean, default: false }, //是否显示购物车
    visiblePay: { type: Boolean, default: true }, //是否显示立即购买
    visibleSellCount: { type: Boolean, default: false }, //是否显示销售数量
    rowCount: { type: Number, default: 1 }, //显示行数
    colCount: { type: Number, default: 10 }, //显示列数
  },

  data() {
    return {
      goodsList: [],
      pi: 0,
      ps: 10,
      specVisible: false,
      sku: {},
      goodsInfo: {
        name: "",
        price: 0,
        originalPrice: 0,
        saleCount: 0,
        goodsId: 0,
        headImage: "",
        spec: "",
        detail: {},
      },
    };
  },

  created() {
    budo_log.debug("#86 get_goods_list_by_store_index, goods-list-block created");

    this.ps = this.rowCount * this.colCount;

    get_goods_list_by_store_index({
      cateId: this.cateId,
      pi: this.pi,
      ps: this.ps,
      tag: this.tags,
    }).then((res) => {
      this.goodsList = res.data.records;
    });
  },

  methods: {
    goGoodsDetail(goodsId) {
      this.$router.push({ path: "goods-detail", query: { goodsId: goodsId } });
    },

    addCart(goods) {
      this.goodsInfo = goods;
      if (this.goodsInfo.spec) {
        this.specVisible = true;

        this.$nextTick(() => {
          this.$refs.spec.initSpecInfo();
        });
      } else {
        mall_util_order_buy_goods(this.goodsInfo.goodsId, 1, true);
      }
    },

    getSpList(arr) {
      if (arr.length < 2) return arr[0] || [];
      return [].reduce.call(arr, function (col, set) {
        let res = [];
        col.forEach((c) => {
          set.forEach((s) => {
            let t = [].concat(Array.isArray(c) ? c : [c]);
            t.push(s);
            res.push(t);
          });
        });

        return res;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .van-grid-item .van-grid-item__content {
  padding: 8px 4px;
}

.goods-info {
  display: inline-block;
  width: 30vw;

  .goods_name {
    width: 100%;
    height: 34px;
    overflow: hidden;
    line-height: 17px;
    font-size: 14px;
    margin: 0;
  }

  .goods_price {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    line-height: 22px;

    .price {
      display: flex;
      flex-direction: row;
      width: 100%;
    }

    .icon {
      width: 18px;
      height: 18px;
      display: block;
    }

    .cert {
      width: 28px;
      height: 22px;
      border-radius: 50%;
      background: #fc3f3f;
      color: white;
      text-align: center;
      line-height: 22px;
    }

    .text {
      font-size: 18px;
      color: #fc3f3f;
    }
  }
}
</style>
